<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.freeze"
          @keydown.esc="dialog.freeze = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Freeze Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div 
                        class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in configHeaders" 
                            :key="index"
                            class="px-0"
                            @click="item.freeze = !item.freeze ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.freeze">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.freeze ? 'font-weight-bold' : ''"
                                :style="item.freeze ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Freeze
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.hide"
          @keydown.esc="dialog.hide = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Hide Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.hide = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in headers" 
                            :key="index"
                            class="px-0"
                            @click="item.hide = !item.hide ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.hide">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.hide ? 'font-weight-bold' : ''"
                                :style="item.hide ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Hide
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.filter"
          @keydown.esc="dialog.filter = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Filter Data
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.filter = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <div>
                
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn 
                @click="dialog.filter = false; fetch();"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Filter
              </v-btn>

              <v-btn 
                @click="dialog.filter = false"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.reset"
          @keydown.esc="dialog.reset = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Reset Password

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.reset = false; dialog.fullscreen = false; selected.reset = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin mereset password <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="resetes()"
                :loading="process.reset"
                :disabled="process.reset"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Reset
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.reset = false; dialog.fullscreen = false; selected.reset = [];"
                :disabled="process.reset"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.role"
          @keydown.esc="dialog.role = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Ubah Hak Akses

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.role = false; dialog.fullscreen = false; selected.role = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider
                    name="Pilih Role" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Pilih Role
                    </div>

                    <v-select
                      v-on:keyup.enter="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Contoh. Admin"

                      hide-details
                      
                      :items="role"
                      item-value="id"
                      item-text="name"
                      :item-color="set_color"

                      v-model="form.role_id"
                      :success="form.role_id !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-2"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.role_id !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-select>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="roles()"
                :loading="process.role"
                :disabled="process.role"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.role = false; dialog.fullscreen = false; selected.role = [];"
                :disabled="process.role"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="kominfoklaten"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Pegawai
                    </span>
                  </div>

                  <v-spacer />

                  <div>
                    <v-btn
                      to="/user/add"
                      color="#4B4B4B"
                      elevation="0"
                      class="body-2 white--text text-capitalize d-flex align-center"
                      style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                      <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                      
                      <span
                        class="ml-2">
                        Tambah
                      </span>
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 py-0 pr-1">
            <v-col
              cols="12"
              md="5"
              class="d-flex align-center">
              <v-text-field
                @click:clear="search = ''; fetch();"
                v-on:keyup.enter="fetch()"

                filled
                rounded
                dense
                single-line

                hide-details
                :color="set_color"
                placeholder="Cari data yang Anda butuhkan . . ."
                append-icon="mdi-magnify"
                clearable

                v-model="search"
                style="border-radius: 10px;">
              </v-text-field>

              <!-- FILTER -->
              <!-- <div class="ml-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      elevation="0"
                      outlined
                      dark
                      min-width="36"
                      color="#7B7B7B"
                      class="text-capitalize px-0"
                      style="border-radius: 10px;"
                      v-bind="attrs"
                      v-on="on"
                      @click="dialog.filter = true">
                      <v-icon size="18">mdi-filter-outline</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Filter
                  </span>
                </v-tooltip>
              </div> -->

              <!-- FREEZE COLUMN -->
              <div class="ml-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      elevation="0"
                      outlined
                      dark
                      min-width="36"
                      color="#7B7B7B"
                      class="text-capitalize px-0"
                      style="border-radius: 10px;"
                      v-bind="attrs"
                      v-on="on"
                      @click="dialog.freeze = true">
                      <v-icon size="18">mdi-table-split-cell</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Freeze
                  </span>
                </v-tooltip>
              </div>

              <!-- HIDE COLUMN -->
              <div class="ml-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      elevation="0"
                      outlined
                      dark
                      min-width="36"
                      color="#7B7B7B"
                      class="text-capitalize px-0"
                      style="border-radius: 10px;"
                      v-bind="attrs"
                      v-on="on"
                      @click="dialog.hide = true">
                      <v-icon size="18">mdi-eye-off-outline</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Hide
                  </span>
                </v-tooltip>
              </div>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-data-table
                  v-model="selected.row"
                  ref="table-grid"
                  class="table-grid"
                  :height="`calc(100vh - ${pagination.total_data > 0 ? '320px' : '248px'})`"
                  :show-select="checkbox"
                  :single-select="true"
                  :loading="process.load"
                  loading-text="Sedang memuat data . . ."
                  loader-height="5"
                  no-results-text="Belum ada data"
                  :options.sync="options"
                  :headers="configHeaders"
                  :items="list"
                  :items-per-page="100"
                  item-key="id"
                  @click:row="rowClick"
                  @toggle-select-all="handleToggleAll($event)"
                  @dblclick:row="doubleClick"
                  hide-default-footer>
                  <template
                    v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
                    v-slot:[`item.${header.value}`]="{ value, index }">
                    <div
                      v-bind:key="header.value">
                      <div v-if="header.format !== 'regex' && header.format !== 'image' && header.format !== 'image_potrait' && header.format !== 'image_landscape' && header.format !== 'action' && header.format !== 'bool' && header.format !== 'status' && header.format !== 'link'">
                        {{ rowFormat(header.format, value) }} 
                      </div>

                      <div v-if="header.format === 'link'"
                        class="cursor-pointer">
                        
                      </div>
        
                      <div v-if="header.format === 'regex'">
                        <span
                          class="two-line">
                          {{ rowFormat(header.format, value) }}
                        </span>
                      </div>
        
                      <div v-if="header.format === 'image'"
                        class="ma-4">
                        <v-avatar
                          size="60"
                          tile
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <v-img 
                            contain
                            width="100%"
                            height="100%"
                            alt="kominfoklaten" 
                            :src="value !== '' ? value : require('@/assets/image/member_default.png')"
                            class="ma-auto">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  size="20"
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-avatar>
                      </div>

                      <div v-if="header.format === 'image_potrait'"
                        class="ma-4">
                        <v-img 
                          contain
                          width="100"
                          height="125"
                          alt="kominfoklaten" 
                          :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                          class="ma-auto"
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="20"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>

                      <div v-if="header.format === 'image_landscape'"
                        class="ma-4">
                        <v-img 
                          contain
                          width="200"
                          height="125"
                          alt="kominfoklaten" 
                          :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                          class="ma-auto"
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="20"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>

                      <div v-if="header.format === 'action'">
                        <v-tooltip 
                          top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              :to="`/user/detail/${value}`"
                              
                              v-bind="attrs"
                              v-on="on"
                              
                              min-width="28"
                              small
                              rounded
                              color="green"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon small>mdi-information-outline</v-icon>
                            </v-btn>
                          </template>

                          <span>Detail</span>
                        </v-tooltip>

                        <v-tooltip 
                          top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              :to="`/user/edit/${value}`"
                              
                              v-bind="attrs"
                              v-on="on"

                              min-width="28"
                              small
                              rounded
                              color="blue"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon small>mdi-square-edit-outline</v-icon>
                            </v-btn>
                          </template>

                          <span>Ubah</span>
                        </v-tooltip>

                        <v-tooltip 
                          top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="toDelete(value)"

                              v-bind="attrs"
                              v-on="on"

                              min-width="28"
                              small
                              rounded
                              color="red"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon small>mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </template>
                          
                          <span>Hapus</span>
                        </v-tooltip>

                        <v-menu
                          right
                          offset-y
                          style="box-shadow: none !important;">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"

                              min-width="28"
                              small
                              rounded
                              color="#37474F"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon small>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>

                          <v-list
                            dense
                            color="#808080"
                            class="py-1 my-2"
                            style="border-radius: 10px !important;">
                            <v-list-item
                              class="px-2">
                              <v-tooltip 
                                right>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    @click="toRole(value)"

                                    v-bind="attrs"
                                    v-on="on"

                                    min-width="28"
                                    small
                                    rounded
                                    color="indigo"
                                    elevation="0"
                                    class="white--text text-capitalize px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon small>mdi-account-settings-outline</v-icon>
                                  </v-btn>
                                </template>

                                <span>Hak Akses</span>
                              </v-tooltip>
                            </v-list-item>

                            <v-list-item
                              class="px-2">
                              <v-tooltip 
                                right>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    @click="toReset(value)"

                                    v-bind="attrs"
                                    v-on="on"
                                    
                                    min-width="28"
                                    small
                                    rounded
                                    color="orange"
                                    elevation="0"
                                    class="white--text text-capitalize px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon small>mdi-lock-reset</v-icon>
                                  </v-btn>
                                </template>

                                <span>Reset Password</span>
                              </v-tooltip>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>

                      <div v-if="header.format === 'bool'"
                        class="d-flex align-center justify-center">
                        <v-switch
                          @change="toStatus(value, index)"
                          v-model="value"
                          color="success"
                          class="ma-auto"
                          hide-details>
                        </v-switch>
                      </div>

                      <div v-if="header.format === 'status'"
                        class="d-flex justify-center">
                        
                      </div>
                    </div>
                  </template>

                  <template v-slot:[`item.index`]="{ index }">
                    {{ lastIndex + index }}
                  </template>

                  <v-progress-linear 
                    v-show="process.load" 
                    slot="progress" 
                    color="white" 
                    indeterminate>
                  </v-progress-linear>
                </v-data-table>

                <pagination v-if="pagination.total_data > 0"
                  @changePage="fetch($event)" 
                  @reloadPage="fetch($event)" 
                  :model="pagination"/>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,

        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          delete: false,
          reset: false,
          role: false,

          filter: false
        },
        
        search: '',

        filter: {
          
        },

        selected: {
          row: [],
          freeze: [],
          delete: [],
          reset: [],
          role: []
        },

        role: [],

        options: {},
        headers: [],
        list: [],
        pagination: {},

        lastIndex: 0,
        limit: 20,

        form: {
          role_id: ''
        },

        process: {
          load: false,

          delete: false,
          reset: false,
          role: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    watch: {
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          
          this.fetch(pagination)
        },
        deep: true
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      }
    },
    mounted () {
      
    },
    methods: {
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = Number(value) + ' %'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },

      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
          order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          'name[lse]': this.search
        }

        this.selected.row = []

        await get(`admin/user/data`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          this.list = []
          this.pagination = {}
            
          if (res.status === 200) {
            this.headers = [
              {
                text: 'Aksi',
                width: '180px',
                value: 'id',
                freeze: true,
                hide: false,
                align: 'center',
                format: 'action'
              },
              {
                text: 'Status',
                width: '100px',
                value: 'is_active',
                freeze: false,
                hide: false,
                align: 'center',
                format: 'bool'
              },
              {
                text: 'Poto Profil',
                width: '100px',
                value: 'image_url',
                freeze: false,
                hide: false,
                format: 'image',
                align: 'center'
              },
              // {
              //   text: 'Nomor Induk Pegawai',
              //   width: '200px',
              //   value: 'nip',
              //   freeze: false,
              //   hide: false
              // },
              {
                text: 'Nama Lengkap',
                width: '300px',
                value: 'name',
                freeze: false,
                hide: false
              },
              {
                text: 'Email',
                width: '200px',
                value: 'email',
                freeze: false,
                hide: false
              },
              {
                text: 'Telepon',
                width: '200px',
                value: 'mobilephone',
                freeze: false,
                hide: false
              },
              // {
              //   text: 'Jenis Kelamin',
              //   width: '200px',
              //   value: 'gender',
              //   freeze: false,
              //   hide: false
              // },
              {
                text: 'Unit',
                width: '400px',
                value: 'unit_title',
                freeze: false,
                hide: false
              },
              {
                text: 'Role',
                width: '200px',
                value: 'role',
                freeze: false,
                hide: false
              },
              {
                text: 'Dibuat Tanggal',
                width: '200px',
                value: 'create_datetime',
                freeze: false,
                hide: false,
                format: 'datetime'
              }
            ]

            this.list = res.results.data
            this.pagination = res.results.pagination

            this.list.map(obj => {
              obj.is_active = obj.is_active === 'Aktif' ? true : false
            })

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },

      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`admin/user/delete`, {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      },

      async toStatus (val, index) {
        let url = val ? 'admin/user/activate' : 'admin/user/deactivate'

        await post(url, {
          data: {
            id: this.list[index].id
          }
        }).then(response => {
          let res = response.data

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = res.message

            this.fetch()
          }
        })
      },

      toReset (id) {
        this.selected.reset = [id]

        this.dialog.reset = true
      },
      async resetes () {
        this.message.error = ''

        this.process.reset = true

        await post(`admin/user/reset_password`, {
          data: {
            id: this.selected.reset[0]
          }
        }).then(response => {
          let res = response.data

          this.process.reset = false

          if (res.status === 200) {

            this.dialog.reset = false

            this.selected.row = []
            this.selected.reset = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      },

      async fetchRole () {
        await get('admin/menu_privilege/data')
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.role = res.results.data
          }
        })
      },

      toRole (id) {
        this.selected.role = [id]

        this.dialog.role = true

        this.fetchRole()
      },
      async roles () {
        this.message.error = ''
        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.role = true

          await post(`admin/user/update_role`, {
            data: {
              id: this.selected.role[0],
              role_id: this.form.role_id
            }
          }).then(response => {
            let res = response.data

            this.process.role = false

            if (res.status === 200) {

              this.dialog.role = false

              this.selected.row = []
              this.selected.role = []
              
              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>